<template>
  <el-dialog :title="title" :visible.sync="show" width="528px" @opened="opened">
    <div class="template">
      <span class="template-tip">批量导入前请下载</span>
      <el-button
        icon="el-icon-download"
        type="text"
        v-preventReClick
        @click="handleDownloadTemplate"
      >
        Excel模板
      </el-button>
    </div>
    <div class="upload">
      <el-input
        readonly
        v-model="file.fileName"
        placeholder="请选择文件"
        size="small"
        style="width: 384px"
      />
      <div id="upload_excel" class="upload-btn">
        <span>选择文件</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="show = false">取消</el-button>
      <el-button
        type="primary"
        size="small"
        @click="handleConfirmImport"
        v-preventReClick
      >
        导入
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { initwebupload } from "@/utils/webuplaoderCon";
export default {
  name: "BatchImport",
  props: {
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      title: "批量导入",
      file: {}
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    opened() {
      this.fileUploadFun();
      this.file = {};
    },
    handleConfirmImport() {
      this.$emit("confirm", this.file, this.done);
    },
    handleDownloadTemplate() {
      this.$emit("download");
    },
    async done(result, data) {
      // eslint-disable-next-line prefer-const
      let { success, fail, link } = data;
      success = parseInt(success) || 0;
      fail = parseInt(fail) || 0;
      const total = success + fail;
      if (result) {
        this.show = false;
        this.$msgbox({
          title: "提示",
          message: `本次成功导入${success ? success + "条" : ""}数据。`,
          type: "success"
        });
      } else {
        await this.$msgbox({
          title: "提示",
          message:
            (total
              ? `本次共导入${total}条数据，其中${fail}条数据导入失败，`
              : "") + "请下载详情查看失败原因并修改后再次批量上传。",
          type: "error",
          showCancelButton: true,
          cancelButtonText: "确认",
          confirmButtonText: "下载详情"
        });
        window.open(link, "_blank");
      }
    },
    backFun(backValue) {
      this.file = backValue;
    },
    beforeFileQueued() {
      this.file = {};
    },
    fileUploadFun() {
      initwebupload(
        "#upload_excel",
        "excel",
        this.backFun,
        null,
        null,
        this.beforeFileQueued
      );
    }
  }
};
</script>
<style lang="scss" scoped>
/*el-dialog*/
/deep/.el-dialog__header {
  padding: 14px 24px;
}

/deep/.el-dialog__body {
  padding: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.09);
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}
/deep/.el-dialog__title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

.template {
  &-tip {
    font-size: 14px;
    font-weight: 500;
    color: #595959;
    line-height: 14px;
  }
}
.upload {
  margin-top: 16px;
  display: flex;
  align-items: center;
  &-btn {
    margin-left: 8px;
    display: inline-block;
    cursor: pointer;
    line-height: 30px;
    min-width: 88px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #368fff;
    text-align: center;
    font-size: 12px;
    color: #368fff;
    vertical-align: middle;
  }
}

/deep/ .webuploader-pick-new {
  height: 100%;
}
</style>
